import Vue from "vue";
import Router from "vue-router";
import indexrouter from "./index";
import sscrouter from "./ssc";
import exprouter from "./exp";
import hulkrouter from "./hulk";
import homerouter from "./home";
import ehrrouter from "./ehr";
import printrouter from "./print";
import pdf2H5 from "./pdf2H5";
import statistics from "./statistics";
import approval from "./approval";
import tips from "./tips";
import file from "./file";
import workbench from "./workbench";
import apply from "./apply";

Vue.use(Router);

export default new Router({
  mode: "history",
  routes: [
    {
      path: "",
      redirect: "/home/index"
    },
    {
      path: "*",
      component: () => import("@/components/index/NoFound.vue")
    },
    {
      path: "/nav",
      name: "nav",
      component: () => import("@/views/Home.vue")
    },
    {
      path: "/download",
      name: "download",
      component: () => import("@/views/Download.vue"),
      meta: {
        title: '下载页'
      }
    },
    {
      path: "/example/:id",
      name: "example",
      component: () => import("@/views/Example.vue"),
      meta: {
        title: '样例'
      }
    },
    indexrouter,
    homerouter,
    sscrouter,
    exprouter,
    hulkrouter,
    ehrrouter,
    printrouter,
    pdf2H5,
    statistics,
    tips,
    approval,
    ...file,
    workbench,
    apply
  ]
});
